import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  allOrders: [],
  pendingOrders: [],
  closedOrders: [],
  cancelOrders: [],
  loading: false,
  error: null,
};

const ordersSlice = createSlice({
  name: "orders",
  initialState,
  reducers: {
    setOrders(state, action) {
      console.log("NICEEE@@@ALL", action.payload);
      state.allOrders = action.payload;
    },
    setPendingOrders(state, action) {
      console.log("NICEEE@@@PENDING", action.payload);
      state.pendingOrders = action.payload;
    },
    setClosedOrders(state, action) {
      console.log("NICEEE@@@CLOSED");
      state.closedOrders = action.payload;
    },
    setCancelOrders(state, action) {
      console.log("NICEEE@@@CANCELLED", action.payload);
      state.cancelOrders = action.payload;
    },
    addOrder(state, action) {
      const { type, payload } = action.payload;

      if (type === "position_closed") {
        state.closedOrders.unshift(payload);
      } else if (type === "order_cancelled") {
        state.cancelOrders.unshift(payload);
      } else if (type === "order_placed") {
        state.allOrders.unshift(payload);
        if (payload.status === "pending") {
          state.pendingOrders.unshift(payload);
        }
      }
    },
    cancelOrder(state, action) {
      const id = action.payload;
      state.pendingOrders = state.pendingOrders.filter(
        (order) => order.id !== id
      );
      state.allOrders = state.allOrders.map((order) =>
        order.id === id ? { ...order, status: "cancelled" } : order
      );
    },
    fillOrder(state, action) {
      const orderId = action.payload.order_id || action.payload;
      state.allOrders = state.allOrders.map((order) =>
        order.id === orderId ? { ...order, status: "filled" } : order
      );
      state.pendingOrders = state.pendingOrders.filter(
        (order) => order.id !== orderId
      );
    },
    updateOrderStatus(state, action) {
      const { order_id, status } = action.payload;
      state.allOrders = state.allOrders.map((order) =>
        order.id === order_id ? { ...order, status } : order
      );
    },
  },
});

export const {
  setOrders,
  setPendingOrders,
  setClosedOrders,
  setCancelOrders,
  addOrder,
  cancelOrder,
  fillOrder,
  updateOrderStatus,
} = ordersSlice.actions;

export default ordersSlice.reducer;
